export default __webpack_public_path__ + "static/media/speed.b14fa9d1.svg";